import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMachineStroke = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_170_100247)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4664 2.78264L8.77496 5.47406C8.48207 5.76696 8.48207 6.24183 8.77496 6.53472L11.4644 9.22416C11.7573 9.51705 12.2322 9.51705 12.525 9.22416L15.2165 6.53273C15.5094 6.23984 15.5094 5.76497 15.2165 5.47207L12.527 2.78264C12.2341 2.48975 11.7593 2.48975 11.4664 2.78264Z",
				stroke: "#0517F8",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.4674 8.78264L14.7759 11.4741C14.483 11.767 14.483 12.2418 14.7759 12.5347L17.4654 15.2242C17.7583 15.5171 18.2331 15.5171 18.526 15.2242L21.2175 12.5327C21.5104 12.2398 21.5104 11.765 21.2175 11.4721L18.528 8.78264C18.2351 8.48975 17.7603 8.48975 17.4674 8.78264Z",
				stroke: "#0517F8",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.46638 8.77385L2.77496 11.4653C2.48207 11.7582 2.48207 12.233 2.77496 12.5259L5.4644 15.2154C5.75729 15.5083 6.23216 15.5083 6.52506 15.2154L9.21648 12.5239C9.50937 12.2311 9.50937 11.7562 9.21648 11.4633L6.52704 8.77385C6.23415 8.48096 5.75928 8.48096 5.46638 8.77385Z",
				stroke: "#0517F8",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4674 14.7739L8.77594 17.4653C8.48304 17.7582 8.48304 18.233 8.77594 18.5259L11.4654 21.2154C11.7583 21.5083 12.2331 21.5083 12.526 21.2154L15.2175 18.5239C15.5104 18.2311 15.5104 17.7562 15.2175 17.4633L12.528 14.7739C12.2351 14.481 11.7603 14.481 11.4674 14.7739Z",
				stroke: "#0517F8",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_170_100247",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMachineStroke;
